<template>
  <div>
    <AdminNav></AdminNav>
    <div class="container">
      <div class="panel-body">
        <div v-if="rows">
          <vue-good-table
            title="User Accounts"
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true,
            }"
            :pagination-options="{
              enabled: true,
              perPage: 10,
            }"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {users} from "../../firebaseConfig";
  import AdminNav from '@/components/AdminNav'

  export default {
    name: 'Users',
    components:{
      AdminNav
    },
    data() {
      return {
        // userList: [],
        columns: [
          {
            label: 'First Name',
            field: 'firstName',
            filterable: true,
          },
          {
            label: 'Last Name',
            field: 'lastName',
            filterable: true,
          },
          {
            label: 'Calendar ID',
            field: 'calendarID',
            filterable: true,
          },
        ],
        rows:[]
      }
    },
    firebase: {
      rows:{
        source: users.limitToLast(150),
        cancelCallBack(err) {
          console.error(err)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #donaldwantsthis {
    text-align: center;
  }
</style>
